import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import "./DevelopersPage.css";
import { API_BASE_URL, IMAGES_BASE_URL } from "../../api/config";
import CustomPagination from "../../components/Shared/CustomPagination";
import { useTranslateKey } from "../../components/translation/useTranslateKey";
import { LangContext } from "../../components/translation/langugeContext";


const DevelopersPage = () => {
  const [developerData, setDevelopers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [projectPage, setProjectPage] = useState(1);
  const [projectTotalPages, setProjectTotalPages] = useState(1);

  //Get developers data from API

  const fetchDevelopers = async (page = 1) => {
    setIsLoading(true); // Start loading
    try {
      const response = await axios.get(
        `${API_BASE_URL}/developers/?page=${page}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      console.log(response.data);
      setDevelopers(response.data.developers);
      setTotalPages(response.data.num_pages);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      if (error.response) {
        console.log("Server responded:", error.response);
      } else if (error.request) {
        console.log("Request made but no response:", error.request);
      } else {
        console.log("Error setting up request:", error.message);
      }
    } finally {
      setIsLoading(false); // End loading
    }
  };

  useEffect(() => {
    fetchDevelopers();
  }, []);

  const handlePageChange = (event, page) => {
    fetchDevelopers(page);
  };

  const { lang } = useContext(LangContext);
  // Get Projects data from API api/get-projects/
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/get-projects/?page=${projectPage}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        console.log("PROJECTS API RESPONSE", response.data);
        setProjects(response.data.projects);
        setProjectTotalPages(response.data.num_pages);
        setProjectPage(response.data.current_page);
      })
      .catch((error) => {
        if (error.response) {
          console.log("Server responded:", error.response);
        } else if (error.request) {
          console.log("Request made but no response:", error.request);
        } else {
          console.log("Error setting up request:", error.message);
        }
      });
  }, [projectPage]);

  const handleProjectPageChange = (event, page) => {
    setProjectPage(page);
  };


  const t = useTranslateKey();
  return (
    <>
      <section
        id="developers"
        className="developers-section container mx-auto px-4  "
      >
        {/* Developer Header */}
        <div className="text-center mb-16 mt-12 ">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-16">
            {t("featured_developers")}
          </h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto  pt-2 pb-2">
            {t("discover_egypt")}
          </p>
        </div>

        {/* Developer cards*/}
        <div className="developer-slider-container px-4 py-8">
          {isLoading ? (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#11132F]">
              <div className="loader"></div>
            </div>
          ) : developerData.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {developerData.map((developer) => (
                <div key={developer.id} className="px-2">
                  {/* Developer card */}
                  <div className="developer-card bg-primary-dark rounded-xl p-6 hover:shadow-lg transition-shadow h-full">
                    <div className="developer-content">
                      <div className="developer-logo w-20 h-20 rounded-full overflow-hidden mx-auto">
                      <img
                          src={`${IMAGES_BASE_URL}${developer.logo}`}
                          alt={`${lang === "ar"
                          ? developer.name_ar || developer.name
                          : developer.name
                          } Logo`}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <h2 className="text-2xl font-bold text-white mt-4 text-center">
                        {lang === "ar"
                          ? developer.name_ar || developer.name
                          : developer.name}
                      </h2>
                      <p className="text-gray-300 mt-2 text-center">
                        {lang === "ar"
                          ? developer.description_ar || developer.description
                          : developer.description}
                      </p>

                      <div className="developer-stats flex justify-between mt-6">
                        <div className="stat-item text-center">
                          <div className="stat-label text-gray-400 text-sm mt-1 capitalize">
                            {t("projects")}
                          </div>
                          <div className="stat-value text-white font-bold text-xl">
                            {developer.projects_count}
                          </div>
                        </div>
                        <div className="stat-item text-center">
                          <div className="stat-label text-gray-400 text-sm mt-1 capitalize">
                            {t("units")}
                          </div>
                          <div className="stat-value text-white font-bold text-xl">
                            {developer.units_completed}
                          </div>
                        </div>
                        <div className="stat-item text-center">
                          <div className="stat-label text-gray-400 text-sm mt-1 capitalize">
                            {t("experience")}
                          </div>
                          <div className="stat-value text-white font-bold text-xl">
                            {developer.years_experience}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-white py-12">
              {t("no_developers")}
            </div>
          )}
        </div>

        {totalPages > 1 && (
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}

        {/* Featured Projects Section */}
        <div className="mt-24">
          <h2 className="text-3xl font-bold text-white mb-8 mt-8">
            {t("featured_projects")}
          </h2>

          {projects && projects.length > 0 ? (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {projects.map((project) => (
                  <div key={project.id} className="px-2">
                    {" "}
                    {/* Add padding between slides */}
                    <div className="project-card bg-primary-dark rounded-xl overflow-hidden">
                      <div className="project-image relative">
                        <img
                          src={`${IMAGES_BASE_URL}${project.image}`}
                            alt={lang === "ar"
                            ? project.name_ar || project.name
                            : project.name}
                          className="w-full h-48 object-cover"
                        />
                        {project.category ? (
                          <span className="project-status absolute top-4 right-4 bg-accent-yellow text-primary-darker px-3 py-1 rounded-full text-xs font-bold">
                          {t(project.category)}
                          </span>
                        ) : null}
                      </div>
                      <div className="project-content p-6">
                        <h3 className="text-xl font-bold text-white mb-2">
                        {lang === "ar"
                          ? project.name_ar || project.name
                          : project.name}
                        </h3>
                        <p className="text-gray-300 mb-4">
                        {lang === "ar"
                          ? project.description_ar || project.description
                          : project.description}
                        </p>
                        <div className="flex justify-between items-center">
                          <span className="text-accent-yellow font-semibold">
                            {t("by")}{" "}
                            {lang === "ar"
                              ? project.developer.name_ar ||
                                project.developer.name
                              : project.developer.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination for Projects */}
              {projectTotalPages > 1 && (
                <div className="mt-8 flex justify-center">
                  <CustomPagination
                    currentPage={projectPage}
                    totalPages={projectTotalPages}
                    onPageChange={handleProjectPageChange}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="text-center text-white py-12">
              {t("no_projects")}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default DevelopersPage;
